import firebase from "firebase/app";
import "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCGPkoMlFUfn9jo7WqMOBkqvYcK6g9kJLM",
  authDomain: "sipakar-singkong.firebaseapp.com",
  databaseURL: "https://sipakar-singkong.firebaseio.com",
  projectId: "sipakar-singkong",
  storageBucket: "sipakar-singkong.appspot.com",
  messagingSenderId: "246166938783",
  appId: "1:246166938783:web:2a3bcc798d5778c5a0aeaa",
};

firebase.initializeApp(firebaseConfig);

const fire = firebase.firestore();

const fs = {
  user: fire.collection("user"),
  gejala: fire.collection("gejala"),
  penyakit: fire.collection("penyakit"),
  diagnosa: fire.collection("diagnosa"),
};

export default fs;
